import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    getServiceAsync,
    TFactories,
    FindFolderRequest,
    FindFolderResponseMessage,
} from '../../../service';
import { runOwsRequestWithMonitor, Feature, ContactFolder } from '../../../shared';
import { baseFolderToUserDeletedFolder } from './converters/peopleFiltersConverter';

function configureFindFolderRequestBody(serviceFactory: TFactories): FindFolderRequest {
    return serviceFactory.findFolderRequest({
        FolderShape: {
            BaseShape: 'IdOnly',
        },
        Paging: null,
        ParentFolderIds: [serviceFactory.distinguishedFolderId({ Id: 'deleteditems' })],
        ShapeName: 'Folder',
        // It's impossible to create sub-folders using PH React, so we don't deep traverse.
        Traversal: 'Shallow',
        Restriction: {
            Item: serviceFactory.isEqualType({
                Item: serviceFactory.propertyUri({
                    FieldURI: 'FolderClass',
                }),
                FieldURIOrConstant: serviceFactory.fieldURIOrConstantType({
                    Item: serviceFactory.constantType({
                        Value: 'IPF.Contact',
                    }),
                }),
            }),
        },
    });
}

export default function getDeletedItemsFolders(): Promise<ContactFolder[]> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'GetDeletedItemsFolders',
            feature: Feature.RestoreDeletedContacts,
            operation: () =>
                service.Operation.findFolderOperation({
                    Header: getJsonRequestHeader(),
                    Body: configureFindFolderRequestBody(service.Factory),
                }),
            transformResponse: response =>
                (response.Body.ResponseMessages
                    .Items[0] as FindFolderResponseMessage).RootFolder.Folders.map(
                    baseFolderToUserDeletedFolder
                ),
        })
    );
}
